import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/SafetyPriorityPage.css";

const SafetyPriorityPage = () => {
  return (
    <>
      <Header />

      <section
        className="safety-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2016/02/saftey.jpg')",
        }}
      ></section>

      <div className="safety-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Safety is Priority</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Safety is Priority
          </h1>

          <div className="safety-content">
            <p className="safety-text" data-aos="fade-up">
              In line with our corporate philosophy, Colombo Dockyard is
              committed and fully equipped to meet all required international
              standards of safety.
            </p>
            <p className="safety-text" data-aos="fade-up" data-aos-delay="100">
              Colombo Dockyard is a member of the British Safety Council,
              signifying a very high level of adherence to international safety
              and quality expectations. We are also compliant with the stringent
              requirements of the International Ship and Port Facility Security
              (ISPS) code developed by the International Maritime Organization
              (IMO).
            </p>
            <p className="safety-text" data-aos="fade-up" data-aos-delay="150">
              Colombo Dockyard also recently embarked on a Behavior Based Safety
              (BBS) program in order to build a strong safety culture across the
              Company's operations and galvanize the workforce by enhancing
              their safety competencies in order to work towards a zero incident
              workplace. The main purpose of this program is to uplift the
              safety standards in the yard to meet emerging challenges.
            </p>
            <p className="safety-text" data-aos="fade-up" data-aos-delay="200">
              The core philosophies of the BBS approach are complementary to
              those of many other programs already implemented. BBS supports
              safety management by giving an avenue for employee involvement and
              a systematic approach to identify and correct behaviors and
              conditions that lead to injuries.
            </p>
            <p className="safety-text" data-aos="fade-up" data-aos-delay="250">
              BBS applies across a broad range of safety areas of the production
              floor, in the office and is applicable off the job as well.
            </p>

            <div className="safety-certificate">
              <a
                href="/wp-content/uploads/2022/07/ISO  14001  2015  -   ISO 45001 2018 Certificate.PDF"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/wp-content/uploads/2022/07/New-HSE-certificate-1-1-1.png"
                  alt="ISO 14001:2015 & ISO 45001:2018 Certificate"
                  data-aos="zoom-in"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default SafetyPriorityPage;
